//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
export default {
  name: "Back",
  computed: {
    ...mapState({
      isApp: (state) => state.isApp, //是否在app打开
    }),
  },
  methods: {
    handleBack() {
      if (window.history.length < 2) {
        this.$router.push("/");
        return;
      }
      this.$router.go(-1);
    },
  },
};



// WEBPACK FOOTER //
// ./src/common/components/back/index.vue